import { AppointmentMedium } from 'constants/appointmentMedium';
import { useFlagEnabled } from 'flagging/hooks';
import { useMe, useMember, useUserAndCareProvider } from 'shared/hooks';
export var useAppointmentLocation = function (medium, location, memberId, userId) {
    var _a, _b, _c, _d, _e;
    var flagEnabled = useFlagEnabled('PROFILE_APPOINTMENT_LOCATION');
    var member = useMember(memberId).data;
    var noteOwner = useUserAndCareProvider(userId).data;
    var me = useMe().data;
    if (!flagEnabled) {
        return location;
    }
    if (medium === AppointmentMedium.phone) {
        return (_a = member === null || member === void 0 ? void 0 : member.phone) !== null && _a !== void 0 ? _a : location;
    }
    else if (medium === AppointmentMedium.video) {
        if (userId) {
            return (_c = (_b = noteOwner === null || noteOwner === void 0 ? void 0 : noteOwner.care_provider) === null || _b === void 0 ? void 0 : _b.zoom_url) !== null && _c !== void 0 ? _c : location;
        }
        else {
            return (_e = (_d = me === null || me === void 0 ? void 0 : me.care_provider) === null || _d === void 0 ? void 0 : _d.zoom_url) !== null && _e !== void 0 ? _e : location;
        }
    }
    else {
        return null;
    }
};
